import { Spinner } from "@blueprintjs/core";

export const LoadingScreen = () => (
  <div className="splash-screen">
    <Spinner intent="primary" size={70} />
    <div className="loading-text">Semgrep.dev is loading</div>
  </div>
);
